// Lien explicite entre une colonne d'un Path DataTable d'itération et un paramètre (variable) du filtre
// du path courant : le path s'exécute une fois par ligne du DataTable, chaque paramètre lié recevant la
// valeur de sa colonne pour la ligne courante.
class DataTableIterationLinkDto {

    // Colonne d'itération : == FieldReferenceIdAndKeyDto.Id (champ exposé du Path DataTable).
    FieldReferenceId: number;

    // Paramètre lié : == FilterParameterVariableDto.DataTableFieldParameterDefinition.Id. Vaut 0 tant que
    // la variable n'a pas été sauvée (le FilterBuilder crée les variables avec un Id de définition à 0,
    // le back déduplique par TechnicalName au save).
    ParameterDefinitionId: number;

    // Clé de résolution stable du paramètre : == FilterParameterVariableDto.TechnicalName. C'est par ce
    // nom que le front (et le back) fait le rapprochement, l'Id pouvant être 0 à l'authoring.
    ParameterTechnicalName: string;

    constructor(fieldReferenceId: number, parameterDefinitionId: number, parameterTechnicalName: string) {
        this.FieldReferenceId = fieldReferenceId;
        this.ParameterDefinitionId = parameterDefinitionId;
        this.ParameterTechnicalName = parameterTechnicalName;
    }
}

export default DataTableIterationLinkDto;
